import React from 'react';

interface ArrowIconProps {
  fill?: string;
  direction?: string;
  width?: number;
  height?: number;
}

const ArrowIcon = ({
                     fill = 'black',
                     direction = 'right',
                     width = 20,
                     height = 14
                   }: ArrowIconProps) => {
  const style = {
    transform: `rotate(${getAngle(direction)}deg)`
  };

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      viewBox='0 0 20 14'
      style={style}
      className='arrow-icon'
    >
      <path
        id='Path_4'
        data-name='Path 4'
        d='M0,5.06V8.484H13.545L8.138,14h5L20,7,13.138,0H8.585l4.96,5.06Z'
        fill={fill}
      />
    </svg>
  );
};

const getAngle = (direction: string) => {
  switch (direction) {
    case 'right':
      return 0;

    case 'bottom':
      return 90;

    case 'left':
      return 180;

    case 'top':
      return 270;

    default:
      0;
  }
};

export default ArrowIcon;
